
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 18 18","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M11.5 8.839L9.956 7.295a.863.863 0 00-1.312 0c-.72.719.933 3.466.212 4.188a.91.91 0 01-1.312 0L6 9.939m4.4-2.2l.824-.825m-4.949 4.95l.825-.825m6.063-7.369a.963.963 0 110 1.927.963.963 0 010-1.927z"}}),_c('path',{attrs:{"d":"M15.47 1.5H9.22c-.284 0-.555.117-.75.325L1.778 8.939a1.023 1.023 0 00.043 1.447l.03.027 6.687 5.833a1.032 1.032 0 001.431-.072l6.253-6.678c.178-.19.277-.44.277-.7v-6.27c0-.567-.461-1.027-1.03-1.026h0z"}})])])
          )
        }
      }
    